/* tslint:disable */
/* eslint-disable */
export enum UserPrebidAlertSuppression {
  None = 'none',
  ThisAuction = 'this_auction',
  UntilNextPrebid = 'until_next_prebid',
  Forever = 'forever'
}
